import { z } from 'zod';
import { addressSchema } from '@area-restrita/client';

import { cnpjSchema } from '@/utils/schema/cnpj';

export const baseCompanySchema = z.object({
  tradingName: z.string().min(1),
  registrationNumber: z.string().min(1).pipe(cnpjSchema),
  companyName: z.string().min(1),
});

export const companyResponsibleSchema = z.object({
  responsibleName: z.string().min(1),
  responsibleEmail: z.string().email(),
  responsiblePhone: z.string().min(1),
});

export const fullCompanySchema = baseCompanySchema
  .merge(companyResponsibleSchema)
  .merge(
    z.object({
      address: addressSchema,
    }),
  );

export type IFullCompanyFormSchema = z.infer<typeof fullCompanySchema>;
